import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { observer,inject } from "mobx-react";

class TagsStr extends Component {
  render() {
    if(!this.props.tags || !this.props.tags.length) {
      return null;
    }

    let Elem="span";
    if(this.props.getUrl) {
      Elem=Link;
    }

    return (
      <div>
        {this.props.tags.map((tag)=>{
          return (
            <Elem key={tag.id} to={this.props.getUrl?this.props.getUrl(tag):null} className="clear tdni b2 hpadd10 dib mright5 mbottom5 rad6 bg-sc1-op90">{this.props.translateStore.lang==='ru'?tag.tag_name_ru:tag.tag_name}</Elem>
          );
        })}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    locale:state.translate.locale
  }
}


export default inject("translateStore")(observer(TagsStr));